import $ from "jquery";

import { getApiUrl } from "../utils/get-api-url";

export const getRulesets = async () => {
  const apiUrl = getApiUrl("ixlogic");
  const fullUrl = `${apiUrl}/ruleset_xml.cfm?export=true`;

  const response = await fetch(fullUrl, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "text/xml;charset=UTF-8"
    }
  });

  const { statusText, ok } = response;
  const text = await response.text();
  if (!ok) throw new Error(text.message || statusText);
  return parse(text);
};

const parse = data => {
  var dataObj = $($.parseXML(data));
  //cycle through ruleset nodes and build an associative array based on the id
  var rulesetArray = [];
  let rulesetsNode = dataObj.find("rulesets");
  rulesetsNode.children().each(function (index, nodeEl) {
    var node = $(nodeEl);
    var ruleID = node.attr("id");
    var fullName = node.find("name").text();

    var obj = {
      id: ruleID,
      name: fullName,
      description: node.find("errorDescription").text(),
      expression: node.find("expression").text(),
      resolution: null
    };

    //setting the ID as the array value and setting the full object as the associative value
    //this is to help with handling the rules-to-flags mapping process in UnderwritingView.js
    rulesetArray[ruleID] = obj;
    rulesetArray.push(ruleID);
  });

  return rulesetArray;
};
